export const cleanAddressLines = (lines: string[]): string[] =>
	lines
		.map(line =>
			line
				.replace(/\s+/g, ' ')
				.replace(/\s*,\s*/g, ', ')
				.replace(/(,\s*){2,}/g, ', ')
				.replace(/^[-\s,./:]+|[-\s,./:]+$/g, '')
		)
		.filter(line => /[a-zA-Z0-9]/.test(line));
